import { Add, Lock, Note, Note1 } from "iconsax-react";
import instance from "../../../../axios/instance";
import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import truncateText from "../../telemedicine/utils/truncate_text";
import NoteComponent from "./component/NoteComponent";
import { LockKeyhole } from "lucide-react";

export default function PatientNotes() {
  const [doc, setDoc] = useState(null);

  async function getDoctor() {
    const res = await instance.get("/doctor", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setDoc(res.data);

    getNotes();
  }

  const { patientInfo } = useLoaderData();

  const [patientNotes, setPatientNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);

  const [isNoteOpen, setIsNoteOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);

  const [createNewNote, setCreateNewNote] = useState(false)

  const token = window.sessionStorage.getItem("ACCESS_TOKEN");

  async function getNotes() {
    setNotesLoading(true);
    instance
      .post(
        "/telemedicine/doctor/get_notes",
        {
          patient_id: patientInfo.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("notes are", response.data);
        setPatientNotes(response.data);
        setNotesLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });
        setPatientNotes([]);
        setNotesLoading(false);
      });
  }

  useEffect(() => {
    getDoctor();
  }, []);

  return (
    <>
      {selectedNote && (
        <NoteComponent
          isOpen={isNoteOpen}
          onClose={() => setIsNoteOpen(false)}
          selectedNote={selectedNote}
          onNoteSaved={() => {
            setIsNoteOpen(false)
            getNotes()
            
          }}
        />
      )}

      {
        createNewNote &&
         <NoteComponent
          patientId={patientInfo.id}
          onNoteSaved={() => {
            setCreateNewNote(false)
            getNotes()
            
          }}
          isOpen={createNewNote}
          onClose={() => setCreateNewNote(false)}
          selectedNote=""
          newNote={true}
        />
      }

      <div className="px-7 py-10 space-y-10">
        <div className="flex justify-between items-center">
          <div className="font-bold text-[16px]">
            Patient Notes ({patientNotes.length})
          </div>

          <button onClick={() => setCreateNewNote(true)} className="flex items-center gap-2 px-4 bg-[#00b0ad] text-white text-[14px] font-medium rounded-[4px] py-3">
            <Add size={18} /> New note
          </button>
        </div>
        
        <div className="space-y-10">
          {patientNotes.length < 1 ? (
            <div className="p-3 text-[14px] text-gray-500">
              No notes for this patient
            </div>
          ) : (
            patientNotes.map((note) => (
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#00b0ad] flex justify-center items-center">
                  <Note variant="Bold" color="#fff" size={20} />
                </div>
                <div
                  onClick={() => {
                    setSelectedNote(note);
                    setIsNoteOpen(true);
                  }}
                  className="flex-1 border p-3 rounded-[8px] space-y-3 cursor-pointer transition-all hover:shadow-md"
                >
                  <div className="font-medium text-[16px]">
                    {note.note_title}
                  </div>
                  <div className="font-normal text-[14px]">
                    {truncateText(note.note, 200)}
                  </div>

                  <div className="flex justify-between items-center text-[12px] font-medium text-gray-500">
                    <div>
                      Created on {new Date(note.created_at).toDateString()}
                    </div>

                    <div className="flex gap-1 items-center">
                      <LockKeyhole size={12} color="gray" />
                      {doc?.id === note.doctor_id
                        ? "You"
                        : note.doctor_name}{" "}
                      signed this note on{" "}
                      {new Date(note.created_at).toDateString()}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}


